import { ConfigurationCategory } from './configuration-category';

export class ServiceConfigurationKey {
  Id: number;
  ServiceId: number;
  Name: string;
  Value: string;
  Description: string;
  AllowEnvironmentOverride: boolean;
  AllowTenantOverride: boolean;
  IsSecret: boolean;
  IsLocked: boolean;
  CategoryId: number;
  CategoryName: string;
  Category: ConfigurationCategory;
}

export class ServiceConfigurationKeyScoped extends ServiceConfigurationKey {
  EnvironmentServiceConfigurationId: number;
  EnvironmentServiceId: number;
  EnvironmentValue: string;
  TenantEnvironmentServiceConfigurationId: number;
  TenantEnvironmentId: number;
  TenantValue: string;
  EffectiveValue: string;
}

export class EnvironmentServiceConfiguration {
  Id: number;
  EnvironmentServiceId: number;
  ServiceConfigurationKeyId: number;
  Value: string;
}

export class TenantEnvrionment {
  Id: number;
  TenantId: number;
  EnvironmentId: number;
  Value: string;
}

export class TenantEnvironmentServiceConfiguration {
  Id: number;
  TenantEnvironmentId: number;
  ServiceConfigurationKeyId: number;
  Value: string;
}

export class ConfigurationSetting {
  Id: number;
  EnvironmentServiceId: number;
  ServiceConfigurationKeyId: number;
  TenantEnvironmentId: number;
  Value: string;  
}

export enum ServiceConfigurationScope {
  Service = 1,
  Environment = 2,
  Tenant = 3
}
